'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _driver = require('./driver');

var _driver2 = _interopRequireDefault(_driver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _driver2.default)('webExtensionLocalStorage', 'local');